import { map, pairwise, switchMap, publishLast, refCount } from 'rxjs/operators';
import { Observable, combineLatest, merge, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { deserialize } from 'santee-dcts';
import { isEqual } from 'lodash';

import { SearchParams, UserEmulationsReadModel, LoadUserParams } from './user-emulation';
import { UserStorage } from '../user';
import { UserInfo } from './user-info';
import { Settings } from '../core';

@Injectable()
export class UserEmulationStorage {
    constructor(
        private http: HttpClient,
        private settings: Settings,
        private userStorage: UserStorage
    ) { }

    public loadUsers(searchParams$: Observable<SearchParams>, page$: Observable<number>): Observable<UserEmulationsReadModel> {
        const userParams$ = combineLatest(searchParams$, page$)
            .pipe(
                map(([searchParams, page]: [SearchParams, number]) => {
                    return {
                        searchParams: searchParams,
                        page: page
                    } as LoadUserParams;
                })
            );

        const usersModel$: Observable<UserEmulationsReadModel> = merge<LoadUserParams>(of(null), userParams$)
            .pipe(
                pairwise(),
                switchMap(([oldParams, newParams]: [LoadUserParams, LoadUserParams]) => {
                    // reset page if search params was changed
                    const page = (oldParams == null || !isEqual(oldParams.searchParams, newParams.searchParams)) ? 1 : newParams.page;

                    return this.http
                        .post(`${this.settings.apiUrl}/emulation/users?page=${page}`, newParams.searchParams)
                        .pipe(
                            map((rawData) => deserialize(rawData, UserEmulationsReadModel)),
                            publishLast(),
                            refCount()
                        );
                })
            );

        return combineLatest(this.userStorage.currentUser, usersModel$)
            .pipe(
                map(([currentUser, usersModel]) => {
                    if (usersModel.users !== null) {
                        usersModel.users.forEach((user: UserInfo) => {
                            user.isEmulationAvailable = (user.userId !== currentUser.metadata.userId);
                        });
                    } 
                    return usersModel;
                })
            );
    }
}